var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fields-module" }, [
    _vm.showNextTemplateButton || _vm.selectedInstanceIndex
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-between mb-3" },
          [
            _c(
              "b-button-group",
              { attrs: { size: "sm" } },
              [
                _vm.showNextTemplateButton
                  ? _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.moveInstanceSelection(1)
                          },
                        },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "arrow-down" } }),
                        _vm._v("\n        Next template\n      "),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedInstanceIndex
                  ? _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.moveInstanceSelection(-1)
                          },
                        },
                      },
                      [
                        _vm._v("\n        Prev template\n        "),
                        _c("b-icon", { attrs: { icon: "arrow-up" } }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.totalTemplateOrder) +
                  "/" +
                  _vm._s(_vm.totalTemplatesCount)
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "layout-sidebar-section" },
      [
        _c(
          "div",
          {
            staticClass: "layout-sidebar-section-title",
            on: {
              click: function ($event) {
                return _vm.$emit("toggleSection", "translateFieldsSelection")
              },
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("b-icon", {
              attrs: {
                icon: _vm.isOpen.translateFieldsSelection
                  ? "chevron-up"
                  : "chevron-down",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "transition",
          [
            _c(
              "b-collapse",
              { attrs: { visible: _vm.isOpen.translateFieldsSelection } },
              [
                _c(
                  "div",
                  [
                    _vm.textFields.length === 0
                      ? _c("b-form-group", [
                          _vm._v(
                            "\n            This template has no text fields\n          "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.textFields.length > 0
                      ? _c(
                          "b-form-group",
                          { staticClass: "translation-form-group mb-0" },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              [
                                _c("Multiselect", {
                                  staticClass:
                                    "flex-grow-1 form-control px-1 py-0 font-base flex items-center ms-bootstrap-size",
                                  staticStyle: {
                                    width: "auto !important",
                                    height: "auto !important",
                                  },
                                  attrs: {
                                    options: _vm.sortedLanguages,
                                    multiple: true,
                                    "close-on-select": false,
                                    "clear-on-select": false,
                                    placeholder: "Choose language(s)...",
                                  },
                                  model: {
                                    value: _vm.translateTargetLanguages,
                                    callback: function ($$v) {
                                      _vm.translateTargetLanguages = $$v
                                    },
                                    expression: "translateTargetLanguages",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.translateTargetLanguages.length <= 1
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "flex-shrink-0 w-100 mt-2",
                                        on: { click: _vm.translate },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Translate\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "flex-shrink-0 w-100 mt-2",
                                    on: { click: _vm.copyAndTranslate },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Copy Template & Translate"),
                                    ]),
                                    _vm._v(" "),
                                    _vm.translateTargetLanguages.length > 1
                                      ? _c(
                                          "b-badge",
                                          {
                                            staticClass: "ml-2",
                                            attrs: { variant: "dark" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.translateTargetLanguages
                                                    .length
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.translateTargetLanguages.length <= 1
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "flex-shrink-0 w-100 mt-2",
                                        on: {
                                          click: _vm.copyFieldsAndTranslate,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Copy Fields & Translate\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("TranslateImageButton", {
                      attrs: {
                        "target-languages": _vm.translateTargetLanguages,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("i", { staticClass: "bi bi-translate green-fonts" }),
      _vm._v(" "),
      _c("strong", [_vm._v(" Translate")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }